import { mensagemPadrao } from 'src/dados-estaticos'
import * as Yup from 'yup'

export const schema = Yup.object().shape({
  turma: Yup.string().required(mensagemPadrao),
  nome: Yup.string().required(mensagemPadrao),
  endereco: Yup.object().shape({
    pais: Yup.string().required(mensagemPadrao),
    cep: Yup.string()
      .required(mensagemPadrao)
      .nullable()
      .when('pais', {
        is: 'Brasil',
        then: field => field.required(mensagemPadrao)
      }),
    logradouro: Yup.string().required(mensagemPadrao),
    numero: Yup.string().required(mensagemPadrao),
    bairro: Yup.string().required(mensagemPadrao),
    cidade: Yup.string().required(mensagemPadrao),
    uf: Yup.string().required(mensagemPadrao)
  })
})
